export const CREDITLINKLIST = [
  {
    id: 1,
    title: '异议申诉',
    image: require('@/static/images/server/1.png'),
    link: '/server/representation',
    color: '#ff757c',
  },
  {
    id: 3,
    title: '统一社会信用代码公示查询',
    image: require('@/static/images/server/3.png'),
    link: '/server/social_find',
    color: '#efa721',
  },
  {
    id: 4,
    title: '失信被执行人查询',
    image: require('@/static/images/server/4.png'),
    link: '/server/break',
    color: '#eb8b61',
  },
  {
    id: 5,
    title: '行政许可/行政处罚查询',
    image: require('@/static/images/server/5.png'),
    link: '/server/administrat_find',
    color: '#0e7581',
  },
  {
    id: 6,
    title: '企业经营异常名录查询',
    image: require('@/static/images/server/6.png'),
    // link: '/server/abnormal_find',
    link: 'https://www.gsxt.gov.cn/index.html', // 修改为外部系统地址
    color: '#fa7d60',
  },
  {
    id: 7,
    title: '信用修复',
    image: require('@/static/images/server/12.png'),
    link: '/repair/country',
    color: '#fa7d60',
  },
  {
    id: 8,
    title: '信用评价',
    image: require('@/static/images/server/13.png'),
    link: '/supervision',
    color: '',
  },
  {
    id: 9,
    title: '信用社区',
    image: require('@/static/images/server/14.png'),
    link: '/social',
    color: '',
  },
  {
    id: 10,
    title: '信易+',
    image: require('@/static/images/server/15.png'),
    link: '/common/letterEasy',
    color: '',
  },
  //   {
  //     id: 11,
  //     title: '政务承诺',
  //     image: require('@/static/images/server/2.png'),
  //     link: '/promisePolitics',
  //     color: '#399a5d',
  //   },
]

export const PUBLICITYTTYPE = [
  // {
  //   id: 1,
  //   title: "信用目录公示",
  //   image: require("@/static/images/publicity/1.png"),
  //   link: "/publicity/honestMenu",
  //   color: "#73b6e0",
  // },
  {
    id: 2,
    title: '行政许可与行政处罚',
    image: require('@/static/images/publicity/2.png'),
    link: '/server/administrat_find',
    color: '#0e7581',
  },
  {
    id: 3,
    title: '信用承诺',
    image: require('@/static/images/publicity/3.png'),
    link: '/promise',
    color: '#eb8b61',
  },
  {
    id: 4,
    title: '守信红名单',
    image: require('@/static/images/publicity/4.png'),
    link: '/publicity/honour',
    color: '#de5547',
  },
  {
    id: 5,
    title: '失信黑名单',
    image: require('@/static/images/publicity/5.png'),
    link: '/publicity/break',
    color: '#50647f',
  },
  {
    id: 6,
    title: '信用修复公示',
    image: require('@/static/images/publicity/13.png'),
    link: '/repair/list',
    color: '#de5547',
  },
  // {
  //   id: 7,
  //   title: '信用目录公示',
  //   image: require('@/static/images/publicity/7.png'),
  //   link: '/common/infoPublicity',
  //   color: '#de5547',
  // },
  {
    id: 7,
    title: '学校食堂信用评级',
    image: require('@/static/images/publicity/7.png'),
    link: '/publicity/schoolcafeteriacreditrating',
    color: '#de5547',
  },
  {
    id: 8,
    title: '行政裁决',
    image: require('@/static/images/publicity/8.png'),
    link: '/publicity/adju',
    color: '#de5547',
  },
  {
    id: 9,
    title: '司法判决',
    image: require('@/static/images/publicity/9.png'),
    link: '/publicity/courtDecision',
    color: '#de5547',
  },
  {
    id: 10,
    title: '信用评价',
    image: require('@/static/images/server/13.png'),
    link: '/publicity/creditLevel',
    color: '#de5547',
  },
  {
    id: 11,
    title: '政务承诺',
    image: require('@/static/images/publicity/4.png'),
    link: '/promisePolitics',
    color: 'rgb(57, 154, 93)',
  },
  {
    id: 12,
    title: '敬请期待',
    image: require('@/static/images/publicity/6.png'),
    link: '',
    color: '#b5b5b5',
  },
]

export const CREDITTYPE = [
  {
    id: 'social_find',
    name: '统一社会信用代码公示查询',
    placeholder: '请输入社会主体名称/统一社会信用代码/工商注册号',
  },
  {
    id: 'break',
    name: '失信被执行人查询',
    placeholder: '请输入主体名称/企业代码',
  },
  {
    id: 'administrat_find',
    name: '行政许可/行政处罚查询',
    placeholder: '请输入社会主体名称/统一社会信用代码/工商注册号/组织机构代码',
  },
  {
    id: 'abnormal_find',
    name: '企业经营异常名录查询',
    placeholder: '请输入企业名称/工商注册码',
  },
]
